import * as React from 'react';
import Svg, { SvgProps, G, Path, Rect } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={35} height={39} {...props}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M24.824 0a2 2 0 012 2v15.4c4.468 1.42 7.705 5.602 7.705 10.541C34.53 34.05 29.58 39 23.471 39a11.041 11.041 0 01-8.795-4.353H2a2 2 0 01-2-2V2a2 2 0 012-2h22.824zM23.47 18.882a9.059 9.059 0 100 18.118 9.059 9.059 0 000-18.118zM24.824 2H2v30.647h11.46a11.016 11.016 0 01-1.048-4.706c0-6.107 4.951-11.059 11.059-11.059.458 0 .91.028 1.353.082V2z"
          fill="#247A9C"
          fillRule="nonzero"
        />
        <Rect fill="#247A9C" x={6.706} y={7.824} width={13.412} height={2.235} rx={1.118} />
        <Rect fill="#247A9C" x={6.706} y={15.647} width={13.412} height={2.235} rx={1.118} />
        <Rect fill="#247A9C" x={6.706} y={23.471} width={8} height={2.235} rx={1.118} />
        <Path
          stroke="#247A9C"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M23.47 21.545v6.396h5.498"
        />
      </G>
    </Svg>
  );
}

const ActivityIcon = React.memo(SvgComponent);
export default ActivityIcon;
